import { fork, put, takeEvery } from 'redux-saga/effects';

import { OPEN_MODAL } from './Modals.actions';
import { getModalIdMacroCase } from './ModalsHelper';

export default [fork(takeOpenModal)];

function* takeOpenModal() {
    yield takeEvery(OPEN_MODAL, function* (action) {
        const modalName = getModalIdMacroCase(action.modalId);
        yield put({ type: `modals/OPEN_POPUP_${modalName} [done]` });
    });
}
